// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_b1f24a3","group":"_4e82a37","groupInformation":"_c11e2c1","event":"_0c6f8bb","eventInformation":"_a448877"};